import SignInView from '@/views/identity/SignInView'
import UserAccountView from '@/views/identity/UserAccountView'
import PasswordResetView from '@/views/identity/PasswordResetView'
import PasswordRequestView from '@/views/identity/PasswordRequestView'
import OAuthSignInView from '@/views/identity/OAuthSignInView'

import { SIGNIN, OAUTH_SIGNIN, USER_ACCOUNT, RESET_PASSWORD, RESET_PASSWORD_REQUEST } from '@/routes/identity'

export default [
  {
    path: '/signin',
    name: SIGNIN,
    component: SignInView,
    meta: { titleKey: 'signin.pageTitle', public: true },
    props: true
  },
  {
    path: '/oauth-login',
    name: OAUTH_SIGNIN,
    component: OAuthSignInView,
    meta: { titleKey: 'signin.pageTitle', public: true },
    props: route => ({ authenticationId: route.query.authentication_id, error: route.query.error === 'true', email: route.query.email })
  },
  {
    path: '/user-account',
    name: USER_ACCOUNT,
    component: UserAccountView,
    meta: { titleKey: 'userAccount.title' }
  },
  {
    path: '/reset-password',
    name: RESET_PASSWORD_REQUEST,
    component: PasswordRequestView,
    props: true,
    meta: { titleKey: 'resetPassword.title', public: true }
  },
  {
    path: '/reset-password/:correlationId',
    name: RESET_PASSWORD,
    component: PasswordResetView,
    props: true,
    meta: { titleKey: 'resetPassword.title', public: true }
  }
]
